<template>
    <section>

      <!-- <div style="height: 10px;">&nbsp;</div> -->

      <!-- <div class="img"> -->
        <div style="width: 100%;" @click="jumpuse">
          <img src="../assets/gaoxiao.jpg" style="width: 100%;height: 100%;" />
        </div>
      <!-- </div> -->

		</section>


</template>

<script>
  import axios from 'axios';
  export default {
    name: 'UseCoupon2',
    data() {
      return {
      };
    },
    components: {},
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;min-height: auto;');
    },
    activated() {},
    methods: {
      jumpuse(){
        this.$router.push({
        	name: 'UseCoupon1',
        	params: {}
        });
      },
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/useCoupon2.vue